// @ts-ignore
export const all = (state) => state.all;

// @ts-ignore
export const one = (state) => state.one;

// @ts-ignore
export const withCompany = (state) => {
  return state.all.filter((guest) => !!guest.ceoId);
};
